// eslint-disable-next-line
export const randomItem = function(arr) {
    return arr[Math.floor(Math.random() * arr.length)]
}
